import { useCallback } from 'react';

import { useOperationalAnalytics } from './use-analytics';

/**
 * Errors which we ignore from SLO reporting to ensure we're only reporting on actionable errors
 */
const nonSLOErrors = [
	/**
	 * These occur when the fetch request fails (usually due to network being offline)
	 */
	/failed to fetch/i,
	/**
	 * These occur when the fetch request fails due to a server response (e.g. 401)
	 */
	/Error server response:/i,
];

function isSLOError(error: Error) {
	// Just checks that none of our non-SLO errors match the error
	return !nonSLOErrors.some((msg) => msg.test(error.message));
}

/**
 * Hook for tracking errors caught in error boundaries
 * Sends operational analytics events with error details
 */
export function useErrorAnalytics({ variantId }: { variantId?: string } = {}): (
	error: Error,
) => void {
	const sendOperationalEvent = useOperationalAnalytics();

	return useCallback(
		(error: Error) => {
			sendOperationalEvent({
				action: 'failed',
				actionSubject: 'modal',
				actionSubjectId: 'editionBenefitsModal',
				attributes: {
					variantId,
					error: error.message,
					errorStack: error.stack,
					errorName: error.name,
					isSLOError: isSLOError(error),
				},
			});
		},
		[sendOperationalEvent, variantId],
	);
}
